import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';

export default function AmbientSound() {
  const audioRef = useRef(null);
  const [active, setActive] = useState(false);
  const [muted, setMuted] = useState(false);
  const location = useLocation();
  // Music has no business playing over a payment flow
  const onCheckout = location.pathname.startsWith('/checkout');

  useEffect(() => {
    const audio = new Audio('/audio/ambient-music.mp3');
    audio.loop = true;
    audio.volume = 0.3;
    // Don't eagerly download ~8MB of music before the visitor interacts
    audio.preload = 'none';
    audioRef.current = audio;

    const startAudio = () => {
      if (window.location.pathname.startsWith('/checkout')) return;
      audio.play().then(() => {
        setActive(true);
      }).catch(() => {});
    };

    const handler = () => {
      startAudio();
      window.removeEventListener('click', handler);
      window.removeEventListener('touchstart', handler);
      window.removeEventListener('scroll', handler);
    };

    window.addEventListener('click', handler, { once: true });
    window.addEventListener('touchstart', handler, { once: true });
    window.addEventListener('scroll', handler, { once: true });

    return () => {
      window.removeEventListener('click', handler);
      window.removeEventListener('touchstart', handler);
      window.removeEventListener('scroll', handler);
      audio.pause();
      audio.src = '';
    };
  }, []);

  const toggle = () => {
    const audio = audioRef.current;
    if (!audio) return;
    if (muted) {
      audio.play().catch(() => {});
      audio.volume = 0.3;
    } else {
      audio.pause();
    }
    setMuted(!muted);
  };

  // Pause while on checkout, resume after (unless the visitor muted it)
  useEffect(() => {
    const audio = audioRef.current;
    if (!audio || !active) return;
    if (onCheckout) audio.pause();
    else if (!muted) audio.play().catch(() => {});
  }, [onCheckout, active, muted]);

  if (!active || onCheckout) return null;

  return (
    <button
      onClick={toggle}
      data-testid="ambient-sound-toggle"
      title={muted ? 'Enable music' : 'Mute music'}
      className="fixed bottom-5 right-5 z-50 w-10 h-10 rounded-full flex items-center justify-center transition-all duration-300"
      style={{
        background: 'rgba(255,255,255,0.25)',
        backdropFilter: 'blur(12px)',
        border: '1px solid rgba(166,124,0,0.2)',
      }}
    >
      {muted ? (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#A67C00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M11 5L6 9H2v6h4l5 4V5z" />
          <line x1="23" y1="9" x2="17" y2="15" />
          <line x1="17" y1="9" x2="23" y2="15" />
        </svg>
      ) : (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#A67C00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M11 5L6 9H2v6h4l5 4V5z" />
          <path d="M15.54 8.46a5 5 0 0 1 0 7.07" />
          <path d="M19.07 4.93a10 10 0 0 1 0 14.14" />
        </svg>
      )}
    </button>
  );
}
